import { ChevronDown, User } from "lucide-react";

const ROWS = [
  { batch: "Batch 1", count: 15, avg: 84, color: "bg-sky-400" },
  { batch: "Batch 2", count: 9, avg: 77, color: "bg-sky-400" },
  { batch: "Batch 3", count: 4, avg: 91, color: "bg-emerald-400" },
];

export default function LandingBatchShowcase() {
  return (
    <section className="px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mx-auto max-w-xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Multi-batch evaluation</span>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            Upload more resumes anytime — old scores never disappear
          </h2>
          <p className="mt-3 text-sm text-muted-foreground sm:text-base">
            Every upload session gets its own collapsible batch table, so you can keep growing your candidate pool for the same job without losing a single result.
          </p>
        </div>

        <div className="mt-10 space-y-3" data-testid="landing-batch-showcase">
          {ROWS.map((r, idx) => (
            <div
              key={r.batch}
              className="overflow-hidden rounded-2xl border border-border/70 bg-card shadow-sm transition-all duration-300 hover:shadow-md animate-in fade-in-0 slide-in-from-bottom-2 glossy-card glossy-sheen"
              style={{ animationDelay: `${idx * 90}ms` }}
            >
              <div className="flex items-center justify-between px-5 py-4">
                <div className="flex items-center gap-3">
                  <span className={`h-2.5 w-2.5 rounded-full ${r.color}`} />
                  <span className="font-heading font-semibold">{r.batch}</span>
                  <span className="flex items-center gap-1 text-xs text-muted-foreground">
                    <User className="h-3 w-3" /> {r.count} candidates
                  </span>
                  <span className="rounded-full bg-primary/10 px-2 py-0.5 font-mono text-xs font-semibold text-primary">Avg {r.avg}%</span>
                </div>
                <ChevronDown className={`h-4 w-4 text-muted-foreground transition-transform duration-200 ${idx === 0 ? "rotate-180" : ""}`} />
              </div>
              {idx === 0 && (
                <div className="border-t border-border/60 bg-muted/30 px-5 py-3 text-xs text-muted-foreground animate-in fade-in-0 slide-in-from-top-1 duration-200">
                  Top candidate: Priya Sharma — 96% match, Exceptional Hire
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
